export const notificationDrawer = {
  notificationDrawerTitle: "通知",
  notificationDrawerDeleteBtn: "删除",
  notificationDrawerDeletedNotification: "通知已删除",
  notificationDrawerDeletedFailed: "通知删除失败",
  notificationMarkReadFailed: "通知标记为已读失败",
  notificationDrawerNotifications: "没有通知",
  notificationDrawerPlay: "打游戏",
  notificationDrawerPlayGame: "前往游戏",
};
